import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { env } from '@amfam/environment';
import { BillingPaymentPaths } from '@amfam/shared/models';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { FaqQuestion } from '@amfam/shared/utility/shared-services';
import { DockingBarService, PageTitleService } from '@amfam/ui-kit';

import { FaqService } from '../../service/faq.service';

@Component({
  selector: 'ds-amfam-billing-faq',
  templateUrl: './billing-faq.component.html',
  standalone: false
})
export class BillingFaqComponent implements OnInit {
  // Make the route constants available on the template
  billingPaths = BillingPaymentPaths;
  public faqContent: Observable<FaqQuestion[]>;
  public isPartner: Observable<boolean>;

  constructor(
    private dockingBarService: DockingBarService,
    private pageTitle: PageTitleService,
    private feature: FeatureFlagService,
    private store: Store,
    private faqService: FaqService
  ) {}

  ngOnInit() {
    this.isPartner = this.store.select(BrandSelectors.selectIsPartner);

    this.faqContent = combineLatest([
      this.store.select(BrandSelectors.selectIsPartner),
      this.store.select(BrandSelectors.selectPrettyClaimPhoneNum),
      this.store.select(BrandSelectors.selectClaimPhoneNumFullHref),
      this.store.select(BrandSelectors.selectCompany)
    ]).pipe(
      map(([isPartner, prettyPhoneNum, hrefPhoneNum, company]) =>
        this.faqService.retrieveFaqContent('billing', {
          isPartner: isPartner,
          prettyPhoneNum: prettyPhoneNum,
          hrefPhoneNum: hrefPhoneNum,
          company: company,
          payNowLink: env.links.payNowURL
        })
      )
    );

    this.dockingBarService.registerHeading('Billing FAQ');
    this.pageTitle.set('Billing FAQ');
  }
}
